import * as React from "react";
import { Switch, Redirect } from "react-router-dom";

import PublicRoute from "components/PublicRoute";

import Login from "./screens/Login";
import Forget from "./screens/Forget";
import Register from "./screens/Register";

const Auth: React.FC = () => {
	return (
		<Switch>
			<Redirect exact from="/auth" to="/auth/login" />
			<PublicRoute restricted path="/auth/login" component={Login} />
			<PublicRoute restricted path="/auth/forget" component={Forget} />
			<PublicRoute restricted path="/auth/register" component={Register} />
		</Switch>
	);
};

export default Auth;
